import {
  PersonFormState,
  NameState,
  JobState,
  AddressesState,
  DegreesState,
  PhonesState,
  EmailState,
} from "../api/Reports";
import { AddressesDefinitions } from "./PersonFormAddresses";
import { AliasesDefinitions } from "./PersonFormAliases";
import { EducationDefinitions } from "./PersonFormEducation";
import { EmailDefinitions } from "./PersonFormEmails";
import { JobDefinitions } from "./PersonFormJob";
import { PhoneDefinitions } from "./PersonFormPhones";
import { SocialDefinitions } from "./PersonFormSocial";

export enum ActionTypes {
  "setBirthdate",
  "setCompany",
  "setBlueprint",
  "setBehaviorKit",
  "setNames",
  "setJobs",
  "setAddresses",
  "setDegrees",
  "setPhones",
  "setEmails",
  "setIdentities",
  "setProfiles",
  "setCustomID",
}
export type SetBirthdateAction = {
  type: ActionTypes.setBirthdate;
  payload: string;
};
export type SetCompanyAction = {
  type: ActionTypes.setCompany;
  payload: string;
};
export type SetBlueprintAction = {
  type: ActionTypes.setBlueprint;
  payload: string;
};
export type SetNamesAction = {
  type: ActionTypes.setNames;
  payload: AliasesDefinitions[];
};

export type SetJobsAction = {
  type: ActionTypes.setJobs;
  payload: JobDefinitions[];
};
export type SetAddressesAction = {
  type: ActionTypes.setAddresses;
  payload: AddressesDefinitions[];
};
export type setDegreesAction = {
  type: ActionTypes.setDegrees;
  payload: EducationDefinitions[];
};
export type SetPhonesAction = {
  type: ActionTypes.setPhones;
  payload: PhoneDefinitions[];
};
export type SetEmailsAction = {
  type: ActionTypes.setEmails;
  payload: EmailDefinitions[];
};
export type SetProfilesAction = {
  type: ActionTypes.setProfiles;
  payload: SocialDefinitions[];
};

export type SetBehaviorKit = {
  type: ActionTypes.setBehaviorKit;
  payload: string;
};

export type SetCustomID = {
  type: ActionTypes.setCustomID;
  payload: string;
};

export type PersonFormActions =
  | SetBirthdateAction
  | SetCompanyAction
  | SetBlueprintAction
  | SetNamesAction
  | SetJobsAction
  | SetAddressesAction
  | setDegreesAction
  | SetPhonesAction
  | SetEmailsAction
  | SetProfilesAction
  | SetBehaviorKit
  | SetCustomID;

export function personFormReducer(
  state: PersonFormState,
  action: PersonFormActions
): PersonFormState {
  switch (action.type) {
    case ActionTypes.setBirthdate:
      return { ...state, birth_date: action.payload };
    case ActionTypes.setCompany:
      return { ...state, company_uuid: action.payload };
    case ActionTypes.setBlueprint:
      return { ...state, blueprint_uuid: action.payload };
    case ActionTypes.setNames:
      const names: NameState[] = action.payload.map((alias) => ({
        first_name: alias.firstName.trim(),
        middle_name: alias.middleName.trim(),
        last_name: alias.lastName.trim(),
        name_type: alias.name_type,
      }));
      return { ...state, names };
    case ActionTypes.setJobs:
      const jobs: JobState[] = action.payload.map((job) => ({
        country: job.country,
        employer: job.company,
        start_date: job.startDate === "" ? undefined : job.startDate,
        end_date: job.endDate === "" ? undefined : job.endDate,
        title: job.title,
      }));
      return { ...state, jobs };
    case ActionTypes.setAddresses:
      const addresses: AddressesState[] = action.payload.map((address) => ({
        city: address.city,
        country: address.country,
        line1: address.street,
        line2: "",
        state: address.state,
        zip: address.zip === "" ? undefined : address.zip,
      }));
      return { ...state, addresses };
    case ActionTypes.setDegrees:
      const degrees: DegreesState[] = action.payload.map((education) => ({
        country: education.country,
        educator: education.institution,
        name: education.degree,
        start_date:
          education.startDate === "" ? undefined : education.startDate,
        end_date: education.endDate === "" ? undefined : education.endDate,
      }));
      return { ...state, degrees };
    case ActionTypes.setPhones:
      const phones: PhonesState[] = action.payload.map((phone) => ({
        raw_number: phone.phone,
      }));
      return { ...state, phones };
    case ActionTypes.setEmails:
      const emails: EmailState[] = action.payload.map((email) => ({
        address: email.email,
      }));
      return { ...state, emails };
    case ActionTypes.setCustomID:
      return { ...state, custom_id: action.payload };
    case ActionTypes.setProfiles:
      const profiles: string[] = action.payload.map((social) => social.url);
      return { ...state, profiles };
    case ActionTypes.setBehaviorKit:
      return { ...state, behavior_kit_uuid: action.payload };
  }
}

export function buildEmptyState(): PersonFormState {
  return {
    birth_date: "",
    blueprint_uuid: "",
    company_uuid: "",
    names: [],
    jobs: [],
    addresses: [],
    degrees: [],
    phones: [],
    emails: [],
    profiles: [],
    behavior_kit_uuid: "",
    custom_id: "",
  };
}
